<template>
  <div class="containerShaded">
      <a href="https://mortor.bandcamp.com/album/burn-up-the-dead" target="_blank"><img src="../assets/Album3.png" alt="" class="cds"></a>
      <a href="https://mortor.bandcamp.com/album/shootem-up" target="_blank"><img src="../assets/Album2.png" alt="" class="cds"></a>
      <a href="https://mortor.bandcamp.com/album/metal-ride" target="_blank"><img src="../assets/Album1.jpg" alt="" class="cds"></a>
  </div>

</template>

<script>
export default {
  name: 'Album',
//   data () {
//     return {
//       msg: 'ALBUMS'
//     }
//   }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.cds{
  width: 100%;
}
/* h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
} */
</style>



// WEBPACK FOOTER //
// src/components/Album.vue